export default {"src":"/_next/static/media/Web.e44e7246.svg","height":48,"width":48};